const state = {
    bidData: {}
}

const mutations = {
    SET_BID_DATA: (state, data) => {
        state.bidData = data
    },
}

export default {
    state,
    mutations
}